import { render, staticRenderFns } from "./ReportByPersonForm.vue?vue&type=template&id=12952ef8&scoped=true&"
import script from "./ReportByPersonForm.vue?vue&type=script&lang=js&"
export * from "./ReportByPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12952ef8",
  null
  
)

export default component.exports